import { __awaiter } from "tslib";
import request from "superagent";
import { log } from "../utils";
export default class HttpClient {
    constructor(configService) {
        this.configService = configService;
    }
    tokenHeaders() {
        return this.configService.isLocalMode()
            ? {}
            : {
                token: this.sessionToken,
                sessionId: this.sessionToken, // this is currently used by the cirrus fetch image endpoint
            };
    }
    get(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, headers = {}, timeout = 1000 * 1200) {
            try {
                headers = Object.assign(Object.assign({}, headers), this.tokenHeaders());
                return yield request.get(url).set(headers).timeout(timeout);
            }
            catch (err) {
                throw HttpClient.createHttpError(err, url);
            }
        });
    }
    getArrayBuffer(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, headers = {}, timeout = 1000 * 1200) {
            try {
                headers = Object.assign(Object.assign({}, headers), this.tokenHeaders());
                return yield request.get(url).set(headers).timeout(timeout).responseType("arraybuffer");
            }
            catch (err) {
                throw HttpClient.createHttpError(err, url);
            }
        });
    }
    static createHttpError(error, url) {
        log.debug("HttpClient error: ", error);
        return new Error(`Error while calling ${url}, caused by: ${error.message}`);
    }
}
//# sourceMappingURL=http-client.js.map